/*
 * Collections EM : interrupteur « Produits marketplace : Afficher / Masquer » (2026-10-06)
 *
 * - Même réglage que la recherche (localStorage em_search_hide_marketplace = '1' pour masquer).
 * - Placé dans la barre « Filtrer et trier » (construite par em-collection-card.js).
 * - Quand « Masquer » est actif :
 *   1. ?view=em-mp-index (templates/collection.em-mp-index.liquid) donne, pour chaque tranche de
 *      250 produits (mêmes filtres, sous-catégorie et tri), le nombre de produits et les positions
 *      des marketplace : compteur exact, et on sait quelles tranches contiennent la page voulue ;
 *   2. ?view=em-mp-cards (templates/collection.em-mp-cards.liquid) renvoie les cartes d'une
 *      tranche sans les marketplace ; on ne charge que les 1 ou 2 tranches utiles ;
 *   3. la page affiche et repagine elle-même (pages pleines, numéros justes).
 * - Caches en mémoire + sessionStorage (index), réappliqué après les filtres / tri AJAX.
 */
(function () {
  const KEY = 'em_search_hide_marketplace';
  const SLICE = 250;
  const isHidden = () => { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const setHidden = (v) => { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} };

  const indexCache = new Map();
  const cardsCache = new Map();
  let caretSvg = '';
  let renderSeq = 0;
  let lastLabel = '';
  let toggle = null;

  // ---------- URL ----------
  function baseParams() {
    const params = new URLSearchParams(location.search);
    ['page', 'view', 'section_id'].forEach((k) => params.delete(k));
    return params;
  }
  function baseUrl() {
    const q = baseParams().toString();
    return location.pathname + (q ? '?' + q + '&' : '?');
  }
  function currentPage() { return Math.max(1, parseInt(new URLSearchParams(location.search).get('page'), 10) || 1); }
  function pageUrl(n) {
    const params = baseParams();
    const v = new URLSearchParams(location.search).get('view');
    if (v && /^par-\d+$/.test(v)) params.set('view', v); // nombre de produits par page choisi
    if (n > 1) params.set('page', String(n));
    const q = params.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  // ---------- Données ----------
  async function fetchText(url) {
    for (let attempt = 0; attempt < 2; attempt++) {
      try { const r = await fetch(url, { credentials: 'same-origin' }); if (r.ok) return await r.text(); } catch (e) {}
    }
    throw new Error('fetch ' + url);
  }

  async function indexPage(base, k) {
    const d = JSON.parse((await fetchText(base + 'view=em-mp-index&page=' + k)).trim());
    if (d.page !== k) throw new Error('index page ' + k);
    return d;
  }

  function loadIndex(base) {
    if (indexCache.has(base)) return indexCache.get(base);
    const p = (async () => {
      try { const c = sessionStorage.getItem('em_mp_idx:' + base); if (c) return JSON.parse(c); } catch (e) {}
      const first = await indexPage(base, 1);
      const rest = await Promise.all(Array.from({ length: Math.max(0, first.pages - 1) }, (_, i) => indexPage(base, i + 2)));
      const slices = [first].concat(rest).map((d) => ({ count: d.count, mp: d.mp.length }));
      const idx = { slices, total: slices.reduce((s, x) => s + x.count - x.mp, 0) };
      try { sessionStorage.setItem('em_mp_idx:' + base, JSON.stringify(idx)); } catch (e) {}
      return idx;
    })();
    indexCache.set(base, p);
    p.catch(() => indexCache.delete(base));
    return p;
  }

  function loadCards(base, k) {
    const key = base + '#' + k;
    if (cardsCache.has(key)) return cardsCache.get(key);
    const p = (async () => {
      const doc = new DOMParser().parseFromString(await fetchText(base + 'view=em-mp-cards&page=' + k), 'text/html');
      const wrap = doc.querySelector('[data-em-mp-cards]');
      if (!wrap || parseInt(wrap.dataset.page, 10) !== k) throw new Error('cards page ' + k);
      const caret = wrap.querySelector('[data-em-mp-caret]');
      if (caret && !caretSvg) caretSvg = caret.innerHTML;
      return Array.from(wrap.querySelectorAll(':scope > li.grid__item')).map((li) => li.outerHTML);
    })();
    cardsCache.set(key, p);
    p.catch(() => cardsCache.delete(key));
    return p;
  }

  // Cartes [start, end) dans la liste filtrée : on ne charge que les tranches concernées
  async function cardsRange(base, idx, start, end) {
    const out = [];
    let offset = 0;
    const needed = [];
    idx.slices.forEach((s, i) => {
      const n = s.count - s.mp;
      if (offset + n > start && offset < end) needed.push({ k: i + 1, offset });
      offset += n;
    });
    const lists = await Promise.all(needed.map((x) => loadCards(base, x.k)));
    lists.forEach((items, i) => {
      const o = needed[i].offset;
      items.forEach((html, j) => { const pos = o + j; if (pos >= start && pos < end) out.push(html); });
    });
    return out;
  }

  // ---------- DOM ----------
  const gridList = () => document.getElementById('product-grid');
  const countEls = () => ['ProductCountDesktop', 'ProductCount'].map((id) => document.getElementById(id)).filter(Boolean);
  const perPage = () => { const l = gridList(); return (l && parseInt(l.dataset.emPerPage, 10)) || 16; };

  function rememberOriginals() {
    const list = gridList();
    if (list && !list.dataset.emMpReplaced) {
      list._emOrig = list.innerHTML;
      const pag = list.parentElement && list.parentElement.querySelector('.pagination-wrapper:not([data-em-mp-pagination])');
      list._emOrigPag = pag || null;
    }
    countEls().forEach((el) => { if (el.textContent.indexOf('hors marketplace') === -1) el.dataset.emMpOrig = el.textContent.trim(); });
  }

  function restoreOriginals() {
    const list = gridList();
    if (list && list.dataset.emMpReplaced && list._emOrig != null) {
      list.innerHTML = list._emOrig;
      delete list.dataset.emMpReplaced;
      const parent = list.parentElement;
      parent.querySelectorAll('[data-em-mp-pagination], [data-em-mp-empty]').forEach((n) => n.remove());
      if (list._emOrigPag && !list._emOrigPag.isConnected) parent.appendChild(list._emOrigPag);
    }
    if (list) list.classList.remove('em-mp-loading');
    countEls().forEach((el) => { if (el.dataset.emMpOrig && el.textContent.trim() !== el.dataset.emMpOrig) el.textContent = el.dataset.emMpOrig; });
    document.documentElement.classList.remove('em-mp-pending');
  }

  function paginationHtml(page, pages) {
    if (pages <= 1) return '';
    const link = (n, label, cls, aria) => `<li><a href="${pageUrl(n)}" data-em-mp-goto="${n}" class="pagination__item ${cls} link" aria-label="${aria}">${label}</a></li>`;
    const parts = [1];
    if (page - 2 > 2) parts.push('…');
    for (let n = Math.max(2, page - 2); n <= Math.min(pages - 1, page + 2); n++) parts.push(n);
    if (page + 2 < pages - 1) parts.push('…');
    parts.push(pages);
    let html = '<div class="pagination-wrapper" data-em-mp-pagination><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';
    if (page > 1) html += link(page - 1, `<span class="svg-wrapper">${caretSvg}</span>`, 'pagination__item--next pagination__item-arrow motion-reduce', 'Page précédente');
    parts.forEach((n) => {
      if (n === '…') html += '<li><span class="pagination__item">…</span></li>';
      else if (n === page) html += `<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${n}">${n}</a></li>`;
      else html += link(n, String(n), '', 'Page ' + n);
    });
    if (page < pages) html += link(page + 1, `<span class="svg-wrapper">${caretSvg}</span>`, 'pagination__item--prev pagination__item-arrow motion-reduce', 'Page suivante');
    return html + '</ul></nav></div>';
  }

  async function renderHidden() {
    const seq = ++renderSeq;
    const list = gridList();
    if (!list) { document.documentElement.classList.remove('em-mp-pending'); return; }
    rememberOriginals();
    list.classList.add('em-mp-loading');
    const base = baseUrl();
    let idx, items, page, pages;
    try {
      idx = await loadIndex(base);
      const per = perPage();
      pages = Math.max(1, Math.ceil(idx.total / per));
      page = Math.min(currentPage(), pages);
      items = await cardsRange(base, idx, (page - 1) * per, page * per);
    } catch (e) {
      if (seq === renderSeq) { setHidden(false); syncButtons(); restoreOriginals(); }
      return;
    }
    if (seq !== renderSeq || !isHidden()) return;
    if (page !== currentPage()) history.replaceState(history.state, '', pageUrl(page));

    const l = gridList();
    if (!l) return;
    l.innerHTML = items.join('');
    l.dataset.emMpReplaced = '1';
    const parent = l.parentElement;
    parent.querySelectorAll('.pagination-wrapper, [data-em-mp-empty]').forEach((n) => n.remove());
    if (idx.total === 0) l.insertAdjacentHTML('beforebegin', '<p class="em-mp-empty" data-em-mp-empty>Aucun produit hors marketplace ici.</p>');
    l.insertAdjacentHTML('afterend', paginationHtml(page, pages));

    lastLabel = idx.total.toLocaleString('fr-FR') + (idx.total > 1 ? ' produits' : ' produit') + ' hors marketplace';
    countEls().forEach((el) => { if (el.textContent.trim() !== lastLabel) el.textContent = lastLabel; });
    l.classList.remove('em-mp-loading');
    document.documentElement.classList.remove('em-mp-pending');
  }

  // ---------- Interrupteur ----------
  function syncButtons() {
    if (!toggle) return;
    const hidden = isHidden();
    toggle.querySelectorAll('[data-mp]').forEach((b) => {
      const on = (b.dataset.mp === 'hide') === hidden;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('em-mp-toggle__opt--on', on);
    });
  }

  function buildToggle() {
    if (document.querySelector('[data-em-mp-toggle]')) return document.querySelector('[data-em-mp-toggle]');
    const el = document.createElement('div');
    el.className = 'em-mp-toggle em-mp-toggle--collection';
    el.setAttribute('data-em-mp-toggle', '');
    el.innerHTML = `<span class="em-mp-toggle__head"><span class="em-mp-toggle__label" id="EmMpToggleLabelColl">Produits marketplace</span><button type="button" class="em-mp-help" data-em-mp-help aria-label="Qu’est-ce qu’un produit marketplace ?" aria-expanded="false">?</button></span>
      <div class="em-mp-toggle__switch" role="radiogroup" aria-labelledby="EmMpToggleLabelColl">
        <button type="button" class="em-mp-toggle__opt" role="radio" aria-checked="false" data-mp="show">Afficher</button>
        <button type="button" class="em-mp-toggle__opt" role="radio" aria-checked="false" data-mp="hide">Masquer</button>
      </div>`;
    const bar = document.querySelector('.em-fs-bar');
    if (bar) {
      const btn = bar.querySelector('.em-fs-btn');
      if (btn) btn.insertAdjacentElement('afterend', el); else bar.appendChild(el);
    } else {
      const c = document.getElementById('ProductGridContainer');
      if (!c) return null;
      el.classList.add('page-width');
      c.parentElement.insertBefore(el, c);
    }
    el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mp]');
      if (!b) return;
      const hide = b.dataset.mp === 'hide';
      if (hide === isHidden()) return;
      setHidden(hide);
      if (currentPage() > 1) history.pushState(history.state, '', pageUrl(1));
      if (!hide) { location.reload(); return; } // retour à la pagination Shopify d'origine
      syncButtons();
      renderHidden();
    });
    return el;
  }

  function init() {
    if (!gridList()) { document.documentElement.classList.remove('em-mp-pending'); return; }
    toggle = buildToggle();
    syncButtons();
    if (isHidden()) renderHidden();
  }

  // Pagination maison (mode « Masquer ») : sans rechargement
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-em-mp-goto]');
    if (!a) return;
    e.preventDefault();
    history.pushState(history.state, '', pageUrl(parseInt(a.dataset.emMpGoto, 10)));
    renderHidden();
    const top = document.querySelector('.em-fs-bar') || document.getElementById('ProductGridContainer');
    if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  });
  window.addEventListener('popstate', () => { if (isHidden()) setTimeout(renderHidden, 50); });

  function watch() {
    // Filtres / tri AJAX : facets.js remplace le contenu de #ProductGridContainer
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(() => {
        const l = gridList();
        if (l && !l.dataset.emMpReplaced) { rememberOriginals(); if (isHidden()) renderHidden(); }
      }).observe(container, { childList: true });
    }
    countEls().forEach((el) => {
      new MutationObserver(() => {
        if (!isHidden() || !lastLabel) return;
        const t = el.textContent.trim();
        if (t.indexOf('hors marketplace') === -1) el.dataset.emMpOrig = t;
        const l = gridList();
        if (t !== lastLabel && l && l.dataset.emMpReplaced) el.textContent = lastLabel;
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // La barre « Filtrer et trier » est construite par em-collection-card.js : on l'attend un peu
  function start() {
    let tries = 0;
    const tick = () => {
      if (document.querySelector('.em-fs-bar') || tries++ > 30) { init(); watch(); }
      else setTimeout(tick, 100);
    };
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
